"use client";
import React, { useCallback, useEffect, useState } from "react";

import stl from "./productImgSwiper.module.scss";
import { useProductDetailsContext } from "@/src/provider";
import { FmIcon } from "@/ui-component";
import { productDetailsStore } from "@/store/pageModules";
import dynamic from "next/dynamic";
import classnames from "classnames";
import { ISizeConversionCanvasData } from "../SizeChart/SizeConversionCanvas";
const ShareComponentDialog = dynamic(() => import("./ShareComponentDialog"));
interface IProps {
    imgListNum: number;
}
const ProductImgSwiperClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    const { imgListNum } = props;
    const [changeVideoIndex, changeImgSrc, setImgIndex] =
        productDetailsStore.useProdcutDetailsStore((state) => [
            state.changeVideoIndex,
            state.changeImgSrc,
            state.setImgIndex,
        ]);
    const [showShare, setShowShare] = useState(false);
    const [productDetail, productImgList, modelImgList, video] =
        useProductDetailsContext((state) => [
            state.productDetail,
            state.productImgList,
            state.modelImgList,
            state.video,
        ]);
    // 提出来imgList
    const getSizeImg = useCallback((): ISizeConversionCanvasData[] => {
        const productInfos = productDetail;
        //产品尺寸图数据
        return productInfos.isNeckglasses
            ? []
            : [
                  {
                      type: "Y",
                      src: productImgList[1],
                      dimensions_bridge: productInfos.dimensions_bridge,
                      dimensions_diagonal: productInfos.dimensions_diagonal,
                      dimensions_height: productInfos.dimensions_height,
                      dimensions_lens: productInfos.dimensions_lens,
                      dimensions_temple: productInfos.dimensions_temple,
                      dimensions_total_width:
                          productInfos.dimensions_total_width,
                  },
                  {
                      type: "X",
                      src: productImgList[2],
                      dimensions_bridge: productInfos.dimensions_bridge,
                      dimensions_diagonal: productInfos.dimensions_diagonal,
                      dimensions_height: productInfos.dimensions_height,
                      dimensions_lens: productInfos.dimensions_lens,
                      dimensions_temple: productInfos.dimensions_temple,
                      dimensions_total_width:
                          productInfos.dimensions_total_width,
                  },
              ];
    }, [productDetail, productImgList]);

    useEffect(() => {
        setImgIndex(imgListNum); // 存服务端渲染的图片totallength
        const sizeImg = getSizeImg();
        // 存尺寸图
        changeImgSrc(sizeImg);
        const videoIndex =
            productImgList.length + modelImgList.length + sizeImg.length;

        //定位到视频位置
        if (video) {
            changeVideoIndex(productDetail.isSun ? videoIndex + 1 : videoIndex);
        }
    }, [
        changeImgSrc,
        changeVideoIndex,
        getSizeImg,
        imgListNum,
        modelImgList.length,
        productDetail.isSun,
        productImgList.length,
        setImgIndex,
        video,
    ]);

    const toggerShare = () => {
        setShowShare((prev) => !prev);
    };

    return (
        <>
            {props.children}
            <FmIcon
                icon={"icon--share"}
                className={classnames(stl["share-button"], stl["share-icon"])}
                onClick={toggerShare}
            />
            <ShareComponentDialog show={showShare} onClose={toggerShare} />
        </>
    );
};

export default ProductImgSwiperClient;
